import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchcommentById = createAsyncThunk(
    'performance/fetchcommentById',
    async ( {Id}: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/comments/${Id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Apprasial');
        }
    }
);

export const createcomment = createAsyncThunk(
    'performance/createcomment',
    async ( data: any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post(`/performance/comments`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Comment');
        }
    }
);